import React from 'react';
import {
  Edit,
  usePermissions,
  useEditContext,
  SimpleForm,
} from 'react-admin';
import { ensureStockTicketIds } from '../../utils/eventFormUtils';

import NoDeleteToolbar from '../../components/form/NoDeleteToolbar';
import {
  StandardProductFormComponent,
  SeatedProductFormComponent,
} from '../../components/stocks/StocksFormComponents';

/**
 * Stock row edit — products for one session / stock.
 * (Session event'ten /stocks listesinden acilir; event edit'e redirect YOK.)
 */
export const StockEdit = (props) => {
  const { permissions } = usePermissions();
  if (!permissions) return null;

  return (
    <Edit title="Edit Stock / Products" {...props} redirect="list">
      <StockEditForm />
    </Edit>
  );
};

const StockEditForm = () => {
  const { record } = useEditContext();
  if (!record) return null;

  const useSeatedForm =
    record.type === 3 ||
    Boolean(record.seatSelections) ||
    Array.isArray(record.stock);

  const eventId = record.event;

  return (
    <SimpleForm
      toolbar={<NoDeleteToolbar />}
      transform={(data) => ({
        ...data,
        stock: ensureStockTicketIds(data.stock),
      })}
      redirect={eventId ? `/stocks?eventID=${eventId}` : '/stocks'}
    >
      {eventId && (
        <p style={{ marginTop: 0 }}>
          <a href={`/#/stocks?eventID=${eventId}`}>← Back to sessions</a>
          {' · '}
          <a href={`/#/events-v2/${eventId}`}>Event edit</a>
        </p>
      )}
      {!useSeatedForm ? (
        <StandardProductFormComponent stock={record} />
      ) : (
        <SeatedProductFormComponent stock={record} />
      )}
    </SimpleForm>
  );
};
